<template>
  <div class="html">
    <banner :title="title" :content="content"></banner>
    <div class="introduce">
      <p class="sub_title">
        服务方法
      </p>
      <div class="content_A">
        <div class="content_list">
          <div>
            【安全通告实施方法】实时监测、
            周期性度量风险隐患；提供最新安全漏洞和威胁(Nday、 Oday、
            系统漏洞、网络攻击）的解决办法以及安全问题描述和相应的处理意见，第一时间通过电子邮箱或其他方式通知用户。
            <br />
            【安全通告类型】安全漏洞通告、 安全事件通告、厂商安全通告、
            应用系统安全通告、 操作系统安全通告等。
          </div>
        </div>
      </div>
    </div>
    <div class="procedure">
      <p class="sub_title">服务流程</p>
      <div class="lct">
        <img src="@/assets/securityServices/notify1.png" alt="" />
      </div>
    </div>
    <div class="cost">
      <p class="sub_title">服务价值</p>
      <div class="lists">
        <div v-for="item in costList" :key="item.id" class="list">
          <div class="item_list">
            <img :src="item.imgUrl" alt="" />
            <div class="content">
              <p class="p1">{{ item.title }}</p>
              <p class="p2">{{ item.content }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import banner from '@/views/securityServices/components/banner.vue'
export default {
  name: 'notify',
  components: {
    banner
  },
  data() {
    return {
      title: '安全通告服务',
      content:
        '安全通告包括对风险的描述、 评级、 影响范围、 处置建议和相关产品的解决方案。 通过安全通告， 可以实时监测、 周期性度量风险隐患， 客户可以根据安全通告信息， 轻松掌握自有IT资产的安全漏洞状态， 及时跟踪修补IT资产湔洞， 提高自身脆弱性管理能力。',

      costList: [
        {
          id: 1,
          title: '威胁提前预警',
          imgUrl: require('@/assets/securityServices/notify2.png'),
          content: '帮助用户了解安全领域的最新发展，面对威胁能够提前预警。'
        },
        {
          id: 2,
          title: '降低运维成本',
          imgUrl: require('@/assets/securityServices/notify3.png'),
          content: '省心省力，降低安全运维的投入和管理成本。'
        },
        {
          id: 3,
          title: '满足合规要求',
          imgUrl: require('@/assets/securityServices/notify4.png'),
          content: '满足了行业监管的信息安全法规、要求等。'
        }
      ]
    }
  }
}
</script>

<style scoped>
@import '../../styles/utils.scss';
</style>
<style lang="less" scoped>
.lct {
  img {
    width: 70%;
    height: auto;
  }
}
::v-deep .p1 {
  font-size: 24px !important;
}
::v-deep .p2 {
  color: #666666 !important;
  font-size: 20px !important;
  line-height: 40px !important;
}
.item_list {
  border-radius: 30px !important;
}
</style>
